import { FastumTicket } from "@boark/shared/types/fastum-ticket";

import { recordIdToId } from "../utils/record-id-to-id";

export function formatFastumTicketLabel(ticket: {
  externalId: string;
  title: string;
}): string {
  return `${ticket.externalId} — ${ticket.title}`;
}

export function resolveFastumTicketIdFromTag(
  tag: string,
  tickets: FastumTicket[],
): string | null {
  const trimmed = tag.trim();
  if (trimmed === "") {
    return null;
  }

  const byLabel = tickets.find(
    (ticket) => formatFastumTicketLabel(ticket) === trimmed,
  );
  if (byLabel) {
    return recordIdToId(byLabel.id);
  }

  const externalId = trimmed.split(" — ")[0]?.trim() ?? trimmed;
  const byExternalId = tickets.find(
    (ticket) => ticket.externalId === externalId,
  );
  if (byExternalId) {
    return recordIdToId(byExternalId.id);
  }

  const byRecordId = tickets.find(
    (ticket) =>
      recordIdToId(ticket.id) === externalId || String(ticket.id) === externalId,
  );
  if (byRecordId) {
    return recordIdToId(byRecordId.id);
  }

  return null;
}
